import styled from 'styled-components';

export const MobileIcon = styled.img`
  margin: auto;
  display: block;

  @media screen and (min-width: 480px) {
    display: none;
  }
`;

export const Card = styled.div`
  border: 4px solid #f5e4c7;
  padding: 32px;

  @media screen and (max-width: 480px) {
    padding: 16px;
  }
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 18px;
`;

export const Description = styled.div`
  display: flex;
`;

export const DescriptionText = styled.p`
  margin-top: 16px;

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

export const Icon = styled.img`
  padding-left: 16px;

  @media screen and (max-width: 480px) {
    display: none;
  }
`;
